import { render } from "./TokenPage.vue?vue&type=template&id=77ca2398&scoped=true"
import script from "./TokenPage.vue?vue&type=script&lang=js"
export * from "./TokenPage.vue?vue&type=script&lang=js"

import "./TokenPage.vue?vue&type=style&index=0&id=77ca2398&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77ca2398"]])

export default __exports__